import React from 'react'
import clsx from 'clsx'
import { ArrowLeft } from 'iconsax-react'
import ReactCrop, { PixelCrop } from 'react-image-crop'
import { useTheme } from '@mui/material'

import BaseModal from '../ChatModals/BaseModal2'
import Button from '../../atoms/Button2'
import { GreyButton } from '../../organisms/ChatWindowV2/Header/EditParticipantsModal'

import { getBlobFromImage } from './helpers'
import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'
interface CropImageProps {
  imgSrc: string
  onClose: () => void
  onCrop: (f: File) => void
}

const title = 'Crop Avatar'

const CropImage: React.FC<CropImageProps> = ({ imgSrc, onClose, onCrop }) => {
  const { isSmall: mobile } = useBreakpoint()
  const theme = useTheme()

  const imgRef = React.useRef<HTMLImageElement>(null)
  const [crop, setCrop] = React.useState<PixelCrop>()

  const classes = useStyles()

  const paperProps = React.useMemo(() => {
    const common = {
      boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
      padding: '0'
    }

    if (mobile) {
      return {
        style: {
          ...common,
          top: '0',
          transform: 'translateX(-50%)',
          borderRadius: '0',
          width: '100vw',
          maxWidth: 'unset',
          minHeight: 'unset',
          height: 'calc(100svh - 62.5px)',
          maxHeight: 'unset'
        }
      }
    }

    return {
      style: {
        ...common,
        borderRadius: '7px',
        width: '520px',
        maxWidth: 'unset'
      }
    }
  }, [mobile])

  const handleCrop = React.useCallback(async () => {
    const blob = await getBlobFromImage(imgRef.current, crop)
    if (blob) {
      const newFile = new File([blob], 'cropped')
      onCrop(newFile)
    }
    onClose()
  }, [crop, onCrop, onClose])

  return (
    <BaseModal
      open
      hideTitle={mobile}
      showX={!mobile}
      title={title}
      onClose={onClose}
      PaperProps2={paperProps}
      classes={{ title: classes.modalTitle, close: classes.modalClose }}
      childrenClass={clsx(classes.children, mobile && classes.mobileChildren)}
    >
      <div className={clsx(classes.root, mobile && classes.mobileRoot)}>
        {mobile && (
          <div className={classes.mobileTitle}>
            <ArrowLeft
              variant='Linear'
              size={theme.size.xl}
              onClick={onClose}
              className={classes.mobileBackArrow}
            />

            <span>{title}</span>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            overflow: 'auto'
          }}
          className={classes.imageHolder}
        >
          <ReactCrop
            crop={crop}
            onChange={crop => setCrop(crop)}
            circularCrop
            aspect={1}
          >
            <img ref={imgRef} alt='Avatar' src={imgSrc} />
          </ReactCrop>
        </div>

        <div
          className={clsx(
            classes.buttonArea,
            mobile && classes.buttonAreaMobile
          )}
        >
          <Button onClick={onClose} className={classes.button}>
            Cancel
          </Button>

          <GreyButton
            onClick={handleCrop}
            mobile={mobile}
            className={classes.button}
          >
            Crop
          </GreyButton>
        </div>
      </div>
    </BaseModal>
  )
}

export default CropImage
